import { useEffect } from "react";
import { ManualInput } from "../../../../utils/form";

const SelectedMedicine = (props) => {
  const { form, name } = props;
  const { setValue, watch } = form;

  const currentTextValue = watch(`${name}.posology`);

  useEffect(() => {
    setValue(`${name}.posology`, currentTextValue);
  }, [currentTextValue, setValue, name]);

  return (
    <ManualInput
      label="Posología"
      {...props}
      required={false}
      name={`${props.name}.posology`}
    />
  );
};

export default SelectedMedicine;
